/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersUserCreateDto } from '../../models/users-user-create-dto';
import { UsersUserResponseDto } from '../../models/users-user-response-dto';

export interface UsersControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: UsersUserCreateDto
}

export function usersControllerCreate(http: HttpClient, rootUrl: string, params: UsersControllerCreate$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersUserResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, usersControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersUserResponseDto>;
    })
  );
}

usersControllerCreate.PATH = '/o2-users/users/{tenant}';
